import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SYSTEM_TOKEN } from "../utilities/constants";
import { useUI } from "../context/ui";

export const useFetch = (url, options, systemToken = false) => {
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(true);
	const { navigate } = useNavigate();
	const { handleLogout, addToastMessage } = useUI();

	useEffect(() => {
		const controller = new AbortController();
		const { signal } = controller;

		const fetchData = async () => {
			setLoading(true);

			try {
				const resp = await fetch(url, {
					...options,
					method: options.method,
					headers: {
						"Content-Type": "application/json",
						"X-JWT-Assertion":
						//  SYSTEM_TOKEN,
						systemToken
							? SYSTEM_TOKEN
							: localStorage.getItem("token"),
					},
					signal,
				});

				if (!resp.ok) {
					if(resp.status === 401){
						addToastMessage({
							status: false,
							message: "Session expired. Please log in again.",
						});
						handleLogout();
						throw new Error(`Error: ${resp.statusText}`);
					}else{
						throw new Error(`Error: ${resp.statusText}`);
					}
				}

				const response = await resp.json();

				if (response.result.responseCode === 403) {
					if (localStorage.removeItem("token") === undefined) {
						navigate("/");
					}
				} else {
					setData(response);
				}
			} catch (err) {
				if (err.name === "AbortError") {
					console.log("Fetch aborted");
				} else {
					setError(err);
				}
			} finally {
				if (!signal.aborted) {
					setLoading(false);
				}
			}
		};

		fetchData();

		return () => {
			controller.abort();
		};
	}, [url]);

	return { data, error, loading };
};
